import { usePageStore } from '@/store';
import { mapState as rootMapState } from 'pinia';

// import util from '../../common/util';
import { mapAsyncData } from '../../plugins/asyncData';
import { freshCenter, fresh } from './async-data';

export default {
    computed: {
        ...rootMapState(usePageStore, {
            searchCenter: store => store.page.searchCenter
        }),
        presetParams({ searchCenter }) {
            if (searchCenter) {
                return this.presetFiltersV2;
            } else {
                let obj = {};
                this.presetFilters.forEach(filter => {
                    if (filter && Array.isArray(filter.values)) {
                        obj[filter.dn] = filter.values.join(
                            filter.split || ','
                        );
                    }
                    if (filter.dn === 'mapSearch') {
                        obj.rect = filter.rect;
                    }
                });
                return obj;
            }
        }
    },
    methods: {
        ...mapAsyncData({
            freshCenter, 
            fresh
        }),
        refresh() {
            if (this.searchCenter) {
                this.freshCenter();
            } else {
                this.fresh();
            }
        }
    }
};
